import { SolType } from '@sol/components';
import { AsmKpiSparkline } from '@asm/components-core/models/asm-kpi-sparkline';

export class AsmDashboardsType {
  public static readonly kpiSparkline = SolType.ofObject<AsmKpiSparkline>('asm.kpiSparkline', {
    value: SolType.number,
    series: SolType.number.array,
  });
}
